//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_PUESTOS = "obtenerPuestos";
export const OBTENER_PUESTO = "obtenerPuesto";
export const REGISTRAR_PUESTO = "registrarPuesto";
export const ACTUALIZAR_PUESTO = "actualizarPuesto";
// mutation types
export const SET_PUESTOS = "setPuestos";
export const SET_PUESTO = "setPuesto";

const state = {
    puestos: [],
    puesto:[]
}

const getters = {
    obtenerPuestos(state) {
      return state.puestos;
    },
}

const actions = {
    async [OBTENER_PUESTOS](context, estadoId) {

        /*
        * Si el estado es null va a traer a todas los Puestos, de lo contrario va a traer los Puestos por estado
        *
        */
        let endpoint = 'api/Puesto'
        if(estadoId){
            endpoint = `api/Puesto/Estado/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PUESTOS, data.data);
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    async [OBTENER_PUESTO](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Puesto/`)
                .then(({ data }) => {
                    context.commit(SET_PUESTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    async [REGISTRAR_PUESTO](context, datosPuesto){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Puesto`, datosPuesto)
                .then(({ data }) => {
                    context.commit(SET_PUESTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [ACTUALIZAR_PUESTO](context, datosPuesto){
        let id = datosPuesto.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Puesto/`, datosPuesto)
                .then(({ data }) => {
                    context.commit(SET_PUESTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }

}

const mutations = {
    [SET_PUESTOS](state, data) {
        state.puestos = data;
    },

    [SET_PUESTO](state, data) {
        state.puesto = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}